<div class="modal-backdrop" *ngIf="modalService.visible" (click)="onBackdropClick()">
  <div class="modal-container" (click)="stopPropagation($event)">
    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Close Button (X) -->
      <button *ngIf="closeOnBackdrop" class="close-button" (click)="closeModal()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <!-- Icon -->
      <div class="icon-container" *ngIf="modalService.config.icon">
        <!-- Error Icon -->
        <div class="icon error" *ngIf="modalService.config.icon === 'error'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#1E293B" />
            <path d="M12 7V13" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <circle cx="12" cy="16.5" r="1.5" fill="white" />
          </svg>
        </div>

        <!-- Warning Icon -->
        <div class="icon warning" *ngIf="modalService.config.icon === 'warning'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#1E293B" />
            <path d="M12 7V13" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <circle cx="12" cy="16.5" r="1.5" fill="white" />
          </svg>
        </div>

        <!-- Info Icon -->
        <div class="icon info" *ngIf="modalService.config.icon === 'info'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#1E293B" />
            <path d="M12 7V7.01" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 10V17" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>

        <!-- Success Icon -->
        <div class="icon success" *ngIf="modalService.config.icon === 'success'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#1E293B" />
            <path d="M8 12L10.5 14.5L16 9" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>

        <!-- Custom Icon (string) -->
        <div class="icon custom"
          *ngIf="modalService.config.icon && !['error', 'warning', 'info', 'success'].includes(modalService.config.icon)">
          <img [src]="modalService.config.icon" alt="Custom icon"
            *ngIf="modalService.config.icon.startsWith('http') || modalService.config.icon.startsWith('/')">
          <span class="material-icon"
            *ngIf="!modalService.config.icon.startsWith('http') && !modalService.config.icon.startsWith('/')">{{ modalService.config.icon }}</span>
        </div>
      </div>

      <!-- Title -->
      <h2 class="modal-title" *ngIf="modalService.config.title">{{ modalService.config.title }}</h2>

      <!-- Description -->
      <p class="modal-description" *ngIf="modalService.config.description">
        {{ modalService.config.description }}
      </p>

      <!-- Action Buttons -->
      <div class="modal-actions"
        *ngIf="modalService.config.mainButton || modalService.config.secondaryButton">
        <!-- Secondary Button -->
        <button *ngIf="modalService.config.secondaryButton" class="btn-secondary"
          (click)="modalService.config.secondaryButton?.action ? modalService.config.secondaryButton.action() : secondaryAction.emit()">
          {{ modalService.config.secondaryButton.text }}
        </button>

        <!-- Main Button -->
        <button *ngIf="modalService.config.mainButton" class="btn-primary"
          [class.loading]="modalService.config.mainButton.loading"
          [disabled]="modalService.config.mainButton.loading"
          (click)="modalService.config.mainButton?.action ? modalService.config.mainButton.action() : onMainButtonClick()">
          <span *ngIf="modalService.config.mainButton.loading" class="spinner"></span>
          <span>{{ modalService.config.mainButton.text }}</span>
        </button>
      </div>
    </div>
  </div>
</div>